import classNames, {Argument} from 'classnames';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import styles from './CollapseButton.less';
import {IconButton} from './IconButton';
import {TranslateUtils} from 'src/js/common/utils';

const I18N = defineMessages({
  COLLAPSE: {
    id: 'common.collapseButton.collapse',
    defaultMessage: 'Collapse',
    description: 'title text for collapse button',
  },
  EXPAND: {
    id: 'common.collapseButton.expand',
    defaultMessage: 'Expand',
    description: 'title text for expand button',
  },
});

interface OwnProps {
  className?: Argument;
  disabled?: boolean;
  isCollapsed?: boolean;
  item?: string | number | Record<string, any>;
  onClick: () => void;
}

type Props = OwnProps;

export const CollapseButton: React.FC<Props> = (props) => {
  const {
    className = '',
    disabled = false,
    isCollapsed = false,
    item,
    onClick,
  } = props;
  const intl = useIntl();

  return (
    <IconButton
      item={item}
      className={classNames(className, {
        [styles.dlCollapseButton]: !disabled,
      })}
      iconClass={isCollapsed ? 'fas fa-chevron-down' : 'fas fa-chevron-up'}
      clickCallback={onClick}
      disabled={disabled}
      titleText={TranslateUtils.translate(
        isCollapsed ? {...I18N.EXPAND} : {...I18N.COLLAPSE},
        intl
      )}
      dataName={'collapseButton'}
      dataAttr={isCollapsed ? 'collapsed' : 'expanded'}
    />
  );
};

CollapseButton.displayName = 'CollapseButton';
